import { useContext, useEffect } from 'react'
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom'

export function useBlocker(blocker, when=true) {
  const navigator = useContext(NavigationContext).navigator

  useEffect(() => {
    if (!when) return

    const unblock = navigator.block((tx) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock() // Unblock the navigation so it can proceed
          tx.retry()
        },
      }

      blocker(autoUnblockingTx) // call your custom blocker logic
    })

    return unblock
  }, [navigator, blocker, when])
}
